import React from 'react';
import styled from 'styled-components';

const SpacerContainer = styled.div`
  div {
    height: 8px;
    width: 120px;
    border-radius: 6px;
    background-color: var(--white);
    margin: 0 auto;
    opacity: 0.5;
  }
`;

export const Spacer = ({bg}) => {
  return (
    <SpacerContainer style={ bg && { backgroundColor: bg }}>
      <div />
    </SpacerContainer>
  )
}
